import React, { useCallback, memo } from 'react'
import Image from 'next/image'
import {
    Card,
    CardContent,
    BlurBackdrop,
    ContentWrapper,
    CardTop,
    CardTitle,
    CardSubtitle,
    CardBottom,
    CheckButton,
    ImageWrapper,
} from './styles'
import ExternalLink from '../../common/external-link'

interface OfferCardProps {
    heading: string
    description?: string
    imageUrl?: string
    url?: string
    buttonText: string
}

const OfferCard: React.FC<OfferCardProps> = ({ heading, description, imageUrl, url, buttonText }) => {
    const handleClick = useCallback(() => {
        if (url) {
            globalThis.location.href = url
        }
    }, [url])

    return (
        <ExternalLink href={url}>
            <Card onClick={handleClick}>
                {imageUrl && (
                    <ImageWrapper>
                        <Image
                            src={imageUrl}
                            alt={heading}
                            fill
                            style={{ objectFit: 'cover' }}
                            sizes="(max-width: 768px) 200px, 220px"
                        />
                    </ImageWrapper>
                )}
                <CardContent>
                    <BlurBackdrop>
                        <ContentWrapper>
                            <CardTop>
                                <CardTitle>{heading}</CardTitle>
                                {description && <CardSubtitle>{description}</CardSubtitle>}
                            </CardTop>
                            <CardBottom>
                                <CheckButton>{buttonText}</CheckButton>
                            </CardBottom>
                        </ContentWrapper>
                    </BlurBackdrop>
                </CardContent>
            </Card>
        </ExternalLink>
    )
}

export default memo(OfferCard)
